exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "div.descriptionContainer {\n  padding-bottom: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/modules/networking/networking-vc/gateways/dialogs/wizard-steps/gateway-cli-settings.scss
// module id = S7mO
// module chunks = 0